import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/UtilisationVinomiam.css'; // Nouveau fichier CSS spécifique

const UtilisationVinomiam: React.FC = () => {
    useEffect(() => {
        // Activer le mode sombre si nécessaire
        const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

        const applyDarkMode = (e: MediaQueryListEvent) => {
            document.body.classList.toggle("dark", e.matches);
        };

        document.body.classList.toggle("dark", darkModeMediaQuery.matches);
        darkModeMediaQuery.addEventListener("change", applyDarkMode);

        return () => darkModeMediaQuery.removeEventListener("change", applyDarkMode);
    }, []);

    return (
        <div className="utilisation-page">
            {/* Titre principal */}
            <header className="utilisation-header">
                <h1 className="utilisation-title">Utilisation de Vinomiam</h1>
            </header>

            {/* Contenu principal */}
            <main className="utilisation-content">
                <section className="utilisation-section">
                    <h2 className="utilisation-subtitle">Bienvenue sur Vinomiam</h2>
                    <p className="utilisation-text">
                        Tout d'abord, je vous remercie de vous être inscrit sur Vinomiam et vous souhaite la bienvenue ! <br />
                        Cette page vous explique comment utiliser l'application Vinomiam pour trouver les meilleurs vins adaptés à vos goûts et à vos besoins. <br/>
                        Votre assistant Vinomiam va pouvoir vous aiguiller tout au long de votre recherche d'un vin parfait. <br/>
                        Il a été conçu dans l'optique que vous puissiez faire appel à un professionnel, un Caviste et un Sommelier en l'occurrence où que vous soyez ! <br/>
                        <br />
                        Petit point sur ce qu'est Vinomiam par ailleurs, je préfère jouer la transparence avec vous. <br />
                        Il s'agit bien entendu d'une Intelligence Artificielle que je contrôle et à qui j'apprends à faire ce que moi je sais déjà faire <br />
                        En revanche, ça n'enlève en rien ma toute présence pour toute la sélection de vin, le perfectionnement des réponses, la maintenance etc ! <br />
                        En espérant malgré tout que ça ne vous pose pas de problème d'échanger avec Vinomiam !
                    </p>
                </section>

                <section className="utilisation-section">
                    <h3 className="utilisation-subsection-title">Fonctionnalités principales</h3>
                    <ul className="utilisation-list">
                        <li>Recommandations personnalisées basées sur vos préférences de goût et ou de votre besoin.</li>
                        <li>Liens vers des vins que j'ai sélectionné moi même, dans la continuité de mon propre travail, celui de Caviste.</li>
                        <li>Outil intuitif pour rechercher des vins par origine ou prix. Toutes les questions autour du vin sont possibles.</li>
                    </ul>
                </section>

                <section className="utilisation-section">
                    <h3 className="utilisation-subsection-title">Moyen d'utilisation</h3>
                    <p className="utilisation-text">
                        Mais alors, quel type de question puis-je poser à Vinomiam ?
                    </p>
                    <ol className="utilisation-list utilisation-ordered-list">
                        <li>Quel vin serait le mieux pour aller avec ma blanquette de veau ? Il aura la réponse.</li>
                        <li>Combien de bouteilles je devrais prendre si on est une cinquantaine à en boire ? Il aura la réponse.</li>
                        <li>Quel cadeau pourrais-je faire pour un proche qui adore le vin ? Il aura la réponse. </li>
                        <li>Je voudrais plutôt un vin qui soit d'Agriculture Biologique ! Il aura la réponse.</li>
                        <li>Je cherche un vin qui a la couleur d'un coucher de soleil, le nez d'un matin de printemps et le goût d'un premier amour. Vous avez ça en stock ? J'espère qu'il aura la réponse.</li>
                    </ol>
                    En résumé, c'est votre Caviste et votre Sommelier de poche, qui saura au mieux vous recommander le vin pour passer un bon moment avec qui que ce soit et avec le plat que vous allez manger.
                </section>

                <section className="utilisation-section">
                    <h3 className="utilisation-subsection-title">Responsabilités</h3>
                    <p className="utilisation-text">
                        Vinomiam est un service de recommandation et ne gère pas directement la vente ou la livraison des produits.
                        Pour toute question liée à une commande, contactez directement le site sur lequel vous avez effectué votre commande.
                    </p>
                </section>
            </main>

            {/* Bouton de retour */}
            <footer className="utilisation-footer">
                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault(); // Empêche le comportement par défaut
                        if (window.history.length > 1) {
                            window.history.back(); // Retourne à la page précédente
                        } else {
                            window.location.href = "/"; // Redirige vers la page d'accueil
                        }
                    }}
                    className="back-button"
                >
                    Retour
                </Link>

            </footer>
        </div>
    );
};

export default UtilisationVinomiam;